module.exports = "/_next/static/images/bca1ee907289972faf7035239adfd2e2-sparkle.svg.webp";